
import OpenWorkTimeApi from '@/api/OpenWorkTimeApi';
import { message } from 'ant-design-vue';
import { defineComponent, inject, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
  props: ['query'],
  setup (props) {
    const workTime = ref<any>({})
    const weekTime = ref([])
    const weekNames = ['日', '一', '二', '三', '四', '五', '六']
    const weekNames2 = ['一', '二', '三', '四', '五', '六', '日']
    const week = ref<any[]>([])
    const hasPermission: any = inject('hasPermission')

    function init (id: number) {
      OpenWorkTimeApi.findByOwner({
        engineerId: id
      }).then(res => {
        workTime.value = res;
        weekTime.value = JSON.parse(res.detailsJson);
        initWeekTime(weekTime.value)
      })
    }
    function initWeekTime (data: Array<any>) {
      week.value = []
      let sunday
      for (const i in data) {
        const obj = {
          day: '星期' + weekNames[i],
          times: data[i]
        }
        if (i === '0') {
          sunday = obj
        } else {
          week.value.push(obj)
        }
      }
      week.value.push(sunday)
    }

    function handleChange (l: number, m: number) {
      const before = week.value[l].times[m - 1]
      const current = week.value[l].times[m]
      const after = week.value[l].times[m + 1]
      if (before && current < before) {
        message.error('当前时间不能小于前一时间')
        week.value[l].times[m] = before
        return
      }

      if (after && current > after) {
        message.error('当前时间不能大于后一时间')
        week.value[l].times[m] = after
      }
    }

    function handleAdd (index: number) {
      if (week.value[index].times.length < 10) {
        week.value[index].times.push('')
        week.value[index].times.push('')
      }
    }

    function handleDelete (index: number) {
      const len = week.value[index].times.length
      if (len > 2) {
        week.value[index].times.splice(len - 2)
      }
    }

    function checkValid () {
      for (let i = 0; i < week.value.length; i++) {
        const times = week.value[i].times
        if (times.length === 0) continue
        for (let j = 1; j < times.length; j++) {
          if (!times[j]) {
            message.error('星期' + weekNames2[i] + '第' + (j + 1) + '个时间未设置');
            return false
          }
          if (times[j] < times[j - 1]) {
            message.error('星期' + weekNames2[i] + '第' + (j + 1) + '个时间小于前一个时间，请重新设置');
            return false
          }
        }
      }
      return true
    }

    function handleSubmit (status: boolean) {
      if (!hasPermission.value('engieer_update')) {
        message.error('暂无权限，请联系管理员。')
        return
      }
      if (checkValid()) {
        const submitData = {
          detailsJson: '',
          engineerId: workTime.value.engineerId,
          id: workTime.value.id,
          status: status
        }
        const weekTime: Record<string, Array<any>> = {}

        for (let i = 0; i < week.value.length; i++) {
          if (i < 6) {
            weekTime[i + 1] = week.value[i].times
          } else {
            weekTime[0] = week.value[i].times
          }
        }
        submitData.detailsJson = JSON.stringify(weekTime)
        OpenWorkTimeApi.saveOrUpdate({
          workTime: submitData
        }).then((res) => {
          if (res > 0) {
            workTime.value.id = res
          }
          message.success('更新成功')
          workTime.value.status = status
        })
      }
    }
    function handleSwitch (val) {
      handleSubmit(val)
    }

    onMounted(() => {
      const { id: pId } = props.query // 父级传来的
      const { id: uId } = useRoute().query // 路由携带的
      init(pId || uId)
    })

    return {
      workTime,
      week,
      hasPermission,
      handleChange,
      handleAdd,
      handleDelete,
      handleSwitch,
      handleSubmit
    }
  }
})
